import { AccredibleApiService } from '@accredible-frontend-v2/services/api';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class LerApiService extends AccredibleApiService {
  protected _patch(
    endpoint: string,
    body: any,
    skipApiUrl = false,
    mock = false,
  ): Observable<HttpResponse<any> | any> {
    const url = skipApiUrl ? endpoint : this.apiUrl + endpoint;

    return !mock
      ? this.http.patch(url, body, {
          headers: this._getHeaders('PATCH', endpoint),
          observe: 'response',
        })
      : this.http.patch(this.mockLocalUrl + endpoint, body);
  }
}
